import AddBlog from '../components/AddBlog'
import ShowBlogs from '../components/ShowBlogs'
import SingleBlog from '../components/SingleBlog'
import EditBlog from '../components/EditBlog'
import VueRouter from "vue-router";

// 路由
// export default VueRouter({
//     routes:[
//         {path:'/',component:ShowBlogs},
//         {path:'/',component:AddBlog},
//     ]

// })

export default new VueRouter({
    routes:[
        {path:'/home',component:ShowBlogs},
        {path:'/add',component:AddBlog},
        {path:'/blog/:id',component:SingleBlog},
        {path:'/edit/:id',component:EditBlog}
    ]
}  
)



// WEBPACK FOOTER //
// ./src/router/index.js